export default function ServiceCard({ tag, title, body, methods, active, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="service-card"
      style={{
        textAlign: 'left',
        width: '100%',
        background: active ? 'var(--ink)' : 'var(--cream-2)',
        color: active ? 'var(--cream)' : 'var(--ink)',
        borderRadius: 'var(--radius-md)',
        padding: '32px 32px 36px',
        border: 'none',
        cursor: 'pointer',
        boxShadow: active ? 'var(--shadow-pop)' : 'var(--shadow-card)',
        transition: 'all 300ms var(--ease-out)',
        transform: active ? 'translateY(-4px)' : 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        minHeight: 320,
        fontFamily: 'var(--font-body)',
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          alignSelf: 'flex-start',
          fontFamily: 'var(--font-body)',
          fontSize: 11,
          fontWeight: 500,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          padding: '6px 12px',
          borderRadius: 999,
          background: active ? 'rgba(246,241,234,0.14)' : 'var(--blue-soft)',
          color: active ? 'var(--blue)' : 'var(--blue-ink)',
        }}
      >
        {tag}
      </span>

      <div
        className="service-card-title"
        style={{
          fontFamily: 'var(--font-display)',
          fontWeight: 400,
          fontSize: 32,
          lineHeight: 1.15,
          letterSpacing: '-0.01em',
          color: active ? 'var(--cream)' : 'var(--ink)',
        }}
      >
        {title}
      </div>

      <div
        style={{
          fontFamily: 'var(--font-body)',
          fontSize: 15,
          lineHeight: 1.65,
          color: active ? 'rgba(246,241,234,0.78)' : 'var(--ink-2)',
          flex: 1,
        }}
      >
        {body}
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {methods.map((m) => (
          <span
            key={m}
            style={{
              fontFamily: 'var(--font-body)',
              fontSize: 11,
              fontWeight: 500,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              padding: '4px 10px',
              borderRadius: 999,
              background: 'transparent',
              boxShadow: active
                ? 'inset 0 0 0 1px rgba(246,241,234,0.28)'
                : 'inset 0 0 0 1px rgba(45,42,38,0.16)',
              color: active ? 'var(--cream)' : 'var(--ink-3)',
            }}
          >
            {m}
          </span>
        ))}
      </div>
    </button>
  );
}
